import { Typography, TypographyProps } from '@mui/material'
import React from 'react'

export interface FieldLabelProps extends TypographyProps {
  children: React.ReactNode
  className?: string
}

const WrappedFieldLabel = ({ children, className, ...props }: FieldLabelProps) => (
  <Typography
    variant="caption"
    className={className}
    sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      minWidth: 0,
      maxWidth: '100%',
      display: 'block',
      ...props.sx,
    }}
    {...props}
  >
    {children}
  </Typography>
)

export default WrappedFieldLabel
